import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#FDF6E3] py-16 px-4 sm:px-6 lg:px-8" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border-2 border-green-500/20 text-center" data-id="element-74">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6" data-id="element-75">
            <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-76" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5a] mb-4" data-id="element-77">
            Garantía de Satisfacción Total
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-78">
            Pruébalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100% de tu dinero.
            <br data-id="element-79" />
            <strong className="text-[#1e3a5a]" data-id="element-80">
              Sin preguntas, sin complicaciones.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}